import { render, staticRenderFns } from "./pos-update-customer.vue?vue&type=template&id=6ff12602"
import script from "./pos-update-customer.vue?vue&type=script&lang=js"
export * from "./pos-update-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports